module.exports = __webpack_public_path__ + "static/couple-sitted-face-right-350w-611741e0243bf8b004dd11ad9163cff7.png";